import axios from '../../../config-axios'
import { ElMessage } from 'element-plus'

export default {
    namespaced: true,
    state: () => ({
        modemList: [],
        modemPageRightPart: {
            loadingFlag: false,
            compressors: []
        },
    }),
    getters: {
        getModemList(state) {
            return state.modemList
        },
        getModemPageRightPartData(state) {
            return state.modemPageRightPart
        },
    },
    mutations: {
        setModemList(state, options) {
            state.modemList = options
        },
        setNewModemToList(state, options) {
            state.modemList = [...state.modemList, options]
        },
        setModemPageRightPartLoadingFlag(state, options) {
            state.modemPageRightPart.loadingFlag = options;
        },
        setModemPageRightPartCompressorsList(state, options) {
            state.modemPageRightPart.compressors = options;
        },
        setModemPageParamModem(state, options) {
            state.modemList = state.modemList.map(el=>{
                if (el.id == options.id) {
                    return options
                } else {
                    return el
                }
             })
        },
    },
    actions: {
        async getApiModemsList(context) {
            await axios.get('modem/').then(response => {
              // console.log(response.data)
              context.commit('setModemList', response.data)
            }).catch(er => {
              ElMessage.error('Ошибка, не удалось получить список модемов')
            })
        },
        async getApiCompressorsByModem(context, options) {
            context.commit('setModemPageRightPartLoadingFlag', true);
            await axios.get('modem/'+options+'/compressors/').then(response=> {
              // console.log(response.data);
              context.commit('setModemPageRightPartCompressorsList', response.data);
              context.commit('setModemPageRightPartLoadingFlag', false);
            }).catch(er => {
              context.commit('setModemPageRightPartLoadingFlag', false);
              ElMessage.error('Ошибка, не удалось получить список компрессоров');
            })
        },
        async postApiModemList(context, options) {
            await axios.post('modem/', options).then(response=>{
              context.commit('setNewModemToList', response.data)
              ElMessage.success('Создан') 
            }).catch(error=>{
              ElMessage.error('Bad request');
            })
        },
        async putApiModemParam(context, options) {
            await axios.put('modem/'+options.id+'/', options).then(response=>{
              console.log(response.data)
              context.commit('setModemPageParamModem', response.data)
              ElMessage.success('Параметры изменены')
            }).catch(er => {
              ElMessage.error('Ошибка, не удалось изменить параметры модема');
            })
        },
    }
}